import { Box, Heading } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import {
  closeCreateExamDataModel,
  openQuestionsListModel,
} from "../../../../modules/admin-modules/models/Actions";
import { getAllBucketsRequest } from "../../../../modules/superadmin-modules/bucket/Actions";
import { getAllChaptersRequest } from "../../../../modules/superadmin-modules/chapters/Actions";
import {
  createExamRequest,
  editExamRequest,
} from "../../../../modules/superadmin-modules/exams/Actions";
import { getAllGroupsRequest } from "../../../../modules/superadmin-modules/groups/Actions";
import { getAllPaymentsRequest } from "../../../../modules/superadmin-modules/payment/Actions";
import { getAllTagsRequest } from "../../../../modules/superadmin-modules/tags/Actions";
import { getAllVideosRequest } from "../../../../modules/superadmin-modules/videos/Actions";
import StepOneForm from "../forms/step-one";

const AddExamData = ({ isAdd, data, setSelectedData, setExamData }) => {
  const [isFormOne, setFormOne] = useState(true);
  const [defaultData, setDefaultData] = useState({});
  const [errorslist, setErrorsList] = useState([]);

  const openExamData = useSelector((state) => state.model.isOpen15);
  const { chapters, isLoading } = useSelector(
    (state) => state.superadminChapters
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (openExamData) {
      dispatch(getAllChaptersRequest());
      dispatch(getAllVideosRequest());
      dispatch(getAllPaymentsRequest());
      dispatch(getAllBucketsRequest());
      dispatch(getAllGroupsRequest());
      dispatch(getAllTagsRequest());
    }
  }, [openExamData]);

  useEffect(() => {
    if (isAdd) {
      setDefaultData({
        time: 0,
        is_timed: 0,
        auto_publish_result: 1,
        published: 1,
        enable: 1,
        redo_flag: 1,
        difficulty: "1",
        bookmark: "0",
        type: "1",
      });
    }
  }, [data, isAdd]);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: defaultData,
    shouldUnregister: true,
  });

  const watchSubType = watch("sub_type") || data?.sub_type;
  const watchTotalQustions = watch("question_number") || data?.question_number;
  const watchBucket = watch("buckets") || data?.buckets;
  const watchTags = watch("tags") || data?.tags;
  const watchTimer = watch("is_timed");
  const watchQuestionWay = watch("random") || data?.random;
  const watchType = watch("type") || data?.type;
  const watchVideo = watch("video_id");

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة اختبار" : "تعديل  اختبار"}
      </Heading>
    </Box>
  );

  const onSubmit = async (values) => {
    setErrorsList([]);
    const totel = {
      ...defaultData,
      ...data,
      chapter_id: data?.chapter?.id,
      exam_bucket: data?.exam_buckets?.map((val) => val?.id),
      ...(data?.payment_subject?.id && {
        payment_subject_id: data?.payment_subject?.id,
      }),
      ...values,
    };

    const requiredKeys = [
      "difficulty",
      "bookmark",
      "type",
      "chapter_id",
      "random",
      "sub_type",
    ];
    
    // Add conditional required keys based on sub_type
    if (totel.sub_type == "2") {
      requiredKeys.push("buckets");
    } else if (totel.sub_type == "3") {
      requiredKeys.push("tags");
    }
    
    requiredKeys?.map((val) => {
      if (!Object.keys(totel).includes(val)) {
        setErrorsList((prev) => [...prev, val]);
      }
    });
    const keys = [
      "created_at",
      "updated_at",
      "course",
      "teacher",
      "edit",
      "delete",
      "Action",
      "Actions",
      "payment_subject",
      "exam_buckets",
      "exam_tags",
      "video",
    ];

    let formData = new FormData();
    let chapters = [];
    for (let key in totel) {
      if (key == "buckets") {
        totel[key]
          ?.filter((val) => val != undefined)
          ?.map((val, idx) => {
            if (val) {
              chapters.push(val);
              formData.append(
                `buckets[${idx}][bucket_id]`,
                val.id ? val.id : val?.bucket_id
              );
              formData.append(
                `buckets[${idx}][no_of_questions]`,
                val.no_of_questions
                  ? val.no_of_questions
                  : totel?.question_number
              );
              formData.append(
                `buckets[${idx}][type]`,
                val.type !== undefined && val.type !== null ? val.type : 0
              );
            }
          });
      } else if (key == "tags") {
        totel[key]
          ?.filter((val) => val != undefined)
          ?.map((val, idx) => {
            if (val) {
              formData.append(
                `tags[${idx}][tag_id]`,
                val.id ? val.id : val?.tag_id
              );
              formData.append(
                `tags[${idx}][no_of_questions]`,
                val.no_of_questions
                  ? val.no_of_questions
                  : totel?.question_number
              );
            }
          });
      } else if (key == "student_group_ids") {
        values?.student_group_ids
          ?.join(",")
          ?.split(",")
          ?.map((val, index) => {
            formData.append(`student_group_ids[${index}]`, val);
          });
      } else if (!keys.includes(key)) {
        if (totel[key] == true) formData.append(key, "1");
        else if (totel[key] == false) formData.append(key, "0");
        else if (totel[key] != null) formData.append(key, totel[key]);
      }
    }
    if (totel["time"] == 0) {
      formData.append("is_timed", 0);
      formData.append("time", 0);
    }
    const action = (data) => {
      dispatch(closeCreateExamDataModel());
      setSelectedData({});
      reset();
      setFormOne(true);

      isAdd && watchQuestionWay == 0 && dispatch(openQuestionsListModel());
    };

    console.log(errorslist, totel);
    if (errorslist?.length == 0) {
      if (isAdd) {
        dispatch(createExamRequest(formData, action));
      } else {
        formData.append("_method", "PUT");

        dispatch(
          editExamRequest({
            id: data?.id,
            formData: formData,
            action: action,
          })
        );
      }
    }
  };

  useEffect(() => {
    if (watchTimer == undefined) setValue("time", null);
  }, [watchTimer]);

  const closeFunc = () => {
    dispatch(closeCreateExamDataModel());
    setSelectedData({});
    reset();
    setFormOne(true);
  };

  useEffect(() => {
    if (watchQuestionWay == 0) setValue("sub_type", 1);
  }, [watchQuestionWay]);

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openExamData}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* first form */}
        <StepOneForm
          data={isAdd ? defaultData : data}
          register={register}
          watchTimer={watchTimer}
          errors={errors}
          isFormOne={isFormOne}
          watchType={watchType}
          setValue={setValue}
          watchSubType={watchSubType}
          watchTotalQustions={watchTotalQustions}
          watchQuestionWay={watchQuestionWay}
          watchBucket={watchBucket}
          watchTags={watchTags}
          watchVideo={watchVideo}
          errorslist={errorslist}
        />
        {/* form two */}
      </form>
    </MainModel>
  );
};

export default AddExamData;
